const {
  STORYBLOK_TOKENS: STORYBLOK_TOKENS_PRD
} = require("../../utils/fdr/storyblok");
const {
  APPTENTIVE_TOKENS: APPTENTIVE_TOKENS_PRD
} = require("../../utils/fdr/apptentive");

module.exports = {
  domain: {
    desktop: "racing.fanduel.com",
    mobile: "racing.fanduel.com",
    talentPicks: "racing.fanduel.com/talent-picks/",
    accountWallet: "account.racing.fanduel.com",
    equibase: "equibase-store.fanduel.com"
  },
  service_host: "service.racing.fanduel.com",
  externalDomain: {
    FDTermsConditions: "https://fanduel.com/terms",
    FDPolicy: "https://fanduel.com/privacy",
    FDRLoginBridge: "https://fanduel.com/sso-auth/fdracing",
    FDRSignup:
      "https://www.fanduel.com/join?next=%2Fsso-auth%2Ffdracing%3Fredirect_uri%3D"
  },
  externalServices: {
    fanduel: "https://api.fanduel.com",
    cpp: "https://promos-api.racing.fanduel.com"
  },
  clientId: "a301e728606047a5b6522727d495b3ed",
  brazeId: "e0b90c9d-dfd9-4809-a627-565a5cd7f3b2",
  storyblokToken: STORYBLOK_TOKENS_PRD.PRODUCTION,
  storyblokVersion: "published",
  appTentiveIos: APPTENTIVE_TOKENS_PRD.IOS.PRODUCTION,
  appTentiveAndroid: APPTENTIVE_TOKENS_PRD.ANDROID.PRODUCTION,
  appTentiveWeb: APPTENTIVE_TOKENS_PRD.WEB.PRODUCTION
};
